import { getGatsbyEnv } from "../../../utilities/environment-variables";

interface GetHTMLTagsArgs {
  noIndexMeta: boolean;
  pageDescription: string;
  title: string;
}

export function getHTMLTags({
  noIndexMeta,
  pageDescription,
  title,
}: GetHTMLTagsArgs) {
  const htmlAuthor = { name: "author", content: "TaskRabbit, Inc." };
  const htmlDescription = { name: "description", content: pageDescription };
  const htmlTitle = { name: "title", content: title };
  const robots = getRobots({ noIndexMeta });
  return [htmlAuthor, htmlDescription, htmlTitle, robots];
}

function getRobots({ noIndexMeta }: { noIndexMeta: boolean }) {
  const environment = getGatsbyEnv();
  const contentSet = new Set();
  if (environment !== "production") {
    contentSet.add("noindex");
  }
  if (environment !== "production") {
    contentSet.add("nofollow");
  }
  if (noIndexMeta) {
    contentSet.add("noindex");
  }
  const content = Array.from(contentSet).join(", ");
  return { name: "robots", content };
}
